import React, { useState } from "react";
import AvensysLogo from "@workspace/main/src/assets/images/AvensysLogo.png";

const CoLogos = ({ imgSrc = null, width = "60px" }) => {
  const [imageExists, setImageExists] = useState(true);

  return (
    <div className="d-flex flex-column gap-1">
      <img
        src={AvensysLogo}
        alt="Avensys Logo"
        style={{ width: width, height: "auto" }}
      />
      {imgSrc && imageExists && (
        <img
          src={imgSrc}
          alt="Logo"
          style={{
            width: "auto",
            maxWidth: width,
            height: "auto",
            maxHeight: "50px",
            objectFit: "contain",
            marginTop: "3px",
          }}
          onError={() => setImageExists(false)}
        />
      )}
    </div>
  );
};

export default CoLogos;
